<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-8">
            <h4 class="fw-bold">Statement of Compliance - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-4 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;"
    tabindex="-1" (click)="TotalBack()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />

      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <div class="row">
          <form [formGroup]="statementform">
            <div class="col-12 col-xxl-10 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <!--<h5 class="fw-bolder font-size-16 mb-3">* Statement of Compliance <span class="text-danger"></span></h5>-->
              <div class="mb-3">
                <textarea class="form-control" rows="6" [appTooltip]="showBubbledata" appNumberdirective formControlName="TextComment" style="font-size:15px" readonly></textarea>
              </div>
            </div>
          </form>
          <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4">
            <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="back()">Back</button>
            <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="insert()">Next</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
